import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { AbstractInt } from "../abstract/AbstractInt.js";
/**
 * @name UInt
 * @description
 * A generic unsigned integer codec. For Substrate all numbers are Little Endian encoded,
 * this handles the encoding and decoding of those numbers. Upon construction
 * the bitLength is provided and any additional use keeps the number to this
 * length. This extends `BN`, so all methods available on a normal `BN` object
 * is available here.
 * @noInheritDoc
 */

export var UInt = /*#__PURE__*/function (_AbstractInt) {
  _inherits(UInt, _AbstractInt);

  var _super = _createSuper(UInt);

  function UInt() {
    _classCallCheck(this, UInt);

    return _super.apply(this, arguments);
  }

  _createClass(UInt, null, [{
    key: "with",
    value: function _with(bitLength, typeName) {
      return /*#__PURE__*/function (_UInt) {
        _inherits(_class, _UInt);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, value, bitLength);
        }

        _createClass(_class, [{
          key: "toRawType",
          value: function toRawType() {
            return typeName || _get(_getPrototypeOf(_class.prototype), "toRawType", this).call(this);
          }
        }]);

        return _class;
      }(UInt);
    }
  }]);

  return UInt;
}(AbstractInt);